<template>
            <div class="w-full xl:px-10 px-5 pb-10 overflow-x-auto" @click="autoSelectInputOnClick">
                <div class="flex flex-nowrap pt-0 pb-10 overflow-x-auto items-start">


                    <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">
                        <header
                            class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
                            <div class="left_coll flex gap-2 items-center">
                                <h2 class="text-white text-lg font-bold cursor-pointer w-full"
                                    :title="$helpers.getByName(mc_daily_sum_prod_mon)">Monday</h2>
                                <div style="z-index: 1; " class="h-[20px]">

                                    <i v-show="showWarningHover(mc_daily_sum_prod_mon, mc_final_options_mon).length > 0 && getAllDay.includes('mon')"
                                        v-on:mouseover="showMonAdditional = true"
                                        v-on:mouseleave="showMonAdditional = false"
                                        class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                                        style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                                    <ul v-if="showMonAdditional" class="absolute bg-white p-4 ml-4"
                                        style="border-radius: 0px 10px 10px 10px;">
                                        <li v-for="additional in showWarningHover(mc_daily_sum_prod_mon, mc_final_options_mon)"
                                            class="block text-black text-sm list-disc pb-1">
                                            {{ additional }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="total_planned_number_mon > 0 && mc_final_options_mon.length > 0" class="w-14">
                                <input type="number"
                                    class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                                    v-model="total_planned_number_mon" :disabled="true">
                            </div>
                            <div class="right_coll">
                                <a v-if="menucycle.is_tenant_admin" href="#" @click="addRecipeOptionMenuCycle(1)">
                                    <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                                </a>
                            </div>
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white pt-2 pr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"/>
      </svg> -->

                        </header>

                        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_mon" />

                        <div v-if="!mc_final_options_mon.length"
                            class="w-full flex flex-wrap items-center justify-center py-2">
                            <div>
                                <div class="text-center pl-8">
                                    <img :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                                </div>
                                <p class="pt-4 pl-2">Nothing Here Yet</p>
                                <a href="#" v-if="menucycle.is_tenant_admin" @click="addRecipeOptionMenuCycle(1)"
                                    class="underline text-center block">Add A Menu Option</a>
                                <button v-if="copied_option_data" type="button"
                                    @click="addOptionPasteScript(mc_final_options_mon.length, 1)"
                                    class="underline text-center block">Paste Menu Option</button>
                            </div>
                        </div>

                        <!-- <div v-else class="h-60 overflow-x-auto"> -->

                        <!-- <Container group-name="1" :should-accept-drop="shouldAcceptDrop" :get-child-payload="getChildPayload_mon" @drop="onDropMethod" @dragenter="checkDrop" @dragover="checkDrop">
                            <Draggable v-for="(mc_option, index) in mc_final_options_mon" :key="mc_option.index" class="px-4 py-4"> -->

                        <draggable class="list-group" :list="mc_final_options_mon" group="menus"
                            @change="event => handleDrag(event, 1)">
                            <template #item="{ element, index }">
                                <div class="px-4 py-4">
                                    <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item"
                                        @mouseover="showAddIcon = true"
                                        @mouseleave="showAddIcon = false">
                                        <ul>
                                            <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                                                <div :title="$helpers.getByName(element.new_total_val)"
                                                    class="cursor-pointer max-w-[60%]">{{ element.name }}
                                                </div>
                                                <input @change="changePlannedNumberValue(element, 'mon')" type="number"
                                                    v-model="element.planned_number"
                                                    class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                                                    autocomplete="off">
                                                <!-- <input  @click="autoSelect($event)"> -->
                                                <div>
                                                    <MenuOption v-if="menucycle.is_tenant_admin"
                                                        @messageFromChildEdit="addOptionEditScript(element, index, 1)"
                                                        @messageFromChildCopy="addOptionCopyScript(element)"
                                                        @messageFromChildPaste="addOptionPasteScript(mc_final_options_mon.length, 1)"
                                                        @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_mon.length, 1)"
                                                        @messageFromChildDelete="addOptionDeleteScript(index, 1)" />
                                                </div>
                                            </li>
                                            <li v-for="(mc_option_recipe, index) in sortedArray(element.recipes)"
                                                class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                                                :title="$helpers.getByName(mc_option_recipe.total_val)">
                                                <div class="flex gap-2"
                                                    @mouseover="hoveredIndex = mc_option_recipe.id+element.id"
                                                    @mouseleave="hoveredIndex = null, is_show = false">
                                                    <div class="text-sm font-bold text-color-first-li">
                                                        <a target="_blank"
                                                        :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                                            {{ mc_option_recipe.name }}
                                                        </a>
                                                    </div>
                                                    <div class="text-sm flex flex-nowrap justify-end h-1.5 relative">
                                                        <span v-if="hoveredIndex !== mc_option_recipe.id+element.id">{{ $helpers.getByFirstName(mc_option_recipe.total_val) }}</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            class="h-5 w-5 menu1-icon-color mr-4 cursor-pointer"
                                                            viewBox="0 0 20 20" fill="currentColor"
                                                            @click="is_show = !is_show"
                                                            v-if="hoveredIndex === mc_option_recipe.id+element.id">
                                                            <path
                                                            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                                        </svg>

                                                        <div v-if="is_show && hoveredIndex === mc_option_recipe.id+element.id" class="
                                                            bg-white popup-shadow py-3 absolute right-10 top-2 rounded-md box-border z-10
                                                            ">
                                                            <ul class="w-full cursor-default">
                                                            <li class="px-4 text-black hover:bg-gray-200">
                                                                <button type="button" @click="
                                                                deleteOptionRecipeButton(
                                                                    mc_option_recipe,
                                                                    element
                                                                )
                                                                ">
                                                                Remove Recipe
                                                                </button>
                                                            </li>
                                                            <li class="px-4 text-black hover:bg-gray-200">
                                                                <button type="button" @click="modalOpen(mc_option_recipe)">
                                                                Replace Recipe
                                                                </button>
                                                            </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </template>
                        </draggable>

                    </div>

                </div>

            </div>
</template>

<script>
import WeekDayTotals from "@/Pages/MenuCycle/WeekDayTotals";
export default {

    components:{
        WeekDayTotals
    },

    data()
    {
        return {
            showMonAdditional: false,
            showTueAdditional: false,
            showWebAdditional: false,
            showThuAdditional: false,
            showFriAdditional: false,
            showSatAdditional: false,
            showSunAdditional: false,

            total_planned_number_mon: 0,
            total_planned_number_tue: 0,
            total_planned_number_wed: 0,
            total_planned_number_thu: 0,
            total_planned_number_fri: 0,
            total_planned_number_sat: 0,
            total_planned_number_sun: 0,

            copied_option_data: '',
            addRecipesOptionModal: false,
            option_number: 0,
        }
    },

    props:[
        'mc_daily_sum_prod_mon',
        'mc_final_options_mon',
        'guideline_data',
        'datas','getAllDay',
        'menucycle'
    ],

    methods: {
        showWarningHover(dayAvg, prod) {
            let gline = this.guideline_data;
            // console.log('showWarningHover', dayAvg, prod, gline);
            let returnText = [];
            for (let i = 0; i < this.datas.length; i++) {
                let gValid = this.$helpers.checkGuildLineVals(gline[this.datas[i]['min']], gline[this.datas[i]['max']], parseFloat(dayAvg[this.datas[i]['name']]), this.datas[i]['type']);
                if (gValid == 'red') {
                    returnText.push(this.datas[i]['name'] + ': ' + this.$helpers.nearestValue(parseFloat(dayAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']]));
                }
            }
            returnText = this.$helpers.getAdditionalProducts(gline, prod, returnText, 'daily');
            console.log('showWarningHover1', returnText, dayAvg, prod);
            return returnText;
        },

        addRecipeOptionMenuCycle(day) {
            this.addRecipesOptionModal = true;

            this.day_number = day;
            if (day == 1) {
                this.option_number = this.mc_final_options_mon.length + 1;
            }
            if (day == 2) {
                this.option_number = this.mc_final_options_tue.length + 1;
            }
            if (day == 3) {
                this.option_number = this.mc_final_options_wed.length + 1;
            }
            if (day == 4) {
                this.option_number = this.mc_final_options_thu.length + 1;
            }
            if (day == 5) {
                this.option_number = this.mc_final_options_fri.length + 1;
            }
            if (day == 6) {
                this.option_number = this.mc_final_options_sat.length + 1;
            }
            if (day == 7) {
                this.option_number = this.mc_final_options_sun.length + 1;
            }
            //console.log(this.mc_final_options_mon);
            this.name = "Option " + this.option_number;
        },

        handleDrag(event, day) {
            if (day == 1) {
                this.sortArrays(this.mc_final_options_mon);
                // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);
                this.totalPlannedNumber('mon');
            } else if (day == 2) {
                this.sortArrays(this.mc_final_options_tue);
                // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);
                this.totalPlannedNumber('tue');
            } else if (day == 3) {
                this.sortArrays(this.mc_final_options_wed);
                // this.mc_daily_sum_prod_wed= this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);
                this.totalPlannedNumber('wed');
            } else if (day == 4) {
                this.sortArrays(this.mc_final_options_thu);
                // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);
                this.totalPlannedNumber('thu');
            } else if (day == 5) {
                this.sortArrays(this.mc_final_options_fri);
                // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);
                this.totalPlannedNumber('fri');
            } else if (day == 6) {
                this.sortArrays(this.mc_final_options_sat);
                // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);
                this.totalPlannedNumber('sat');
            } else if (day == 7) {
                this.sortArrays(this.mc_final_options_sun);
                // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);
                this.totalPlannedNumber('sun');
            }
        },

        addOptionPasteScript(total, day) {
            if (this.copied_option_data != '') {
                if (confirm("Are you sure you want to paste here?")) {
                    this.day_number = day;
                    this.option_number = parseInt(total) + 1;
                    this.closeOptionsModal(this.copied_option_data.recipes, this.copied_option_data.photo, day, this.option_number, this.copied_option_data.name);
                }
            } else {
                this.$toast.error('Error: Copy required first!');
            }

        },

        changePlannedNumberValue(element, day) {
            element.planned_number = Math.abs(element.planned_number);
            if (element.planned_number < 0) {
                element.planned_number = 1;
            }
            this.totalPlannedNumber(day);
        },

        addOptionEditScript(option_data, option_number, day) {
            this.addRecipesOptionModal = true;

            this.option_number = option_number + 1;
            this.day_number = day;

            //this.editOptionData = [];
            this.editOptionData = option_data;
            this.name = option_data.name;
            this.plannedNumber = option_data.planned_number;
        },

        addOptionCopyScript(option_data) {
            if (confirm("Are you sure you want to copy this option?")) {
                this.copied_option_data = this.convertOptionData(option_data);
            }
        },

        addOptionDuplicateScript(option_data, total, day) {
            if (confirm("Are you sure you want to duplicate this option?")) {
                let od = JSON.stringify(option_data);
                od = JSON.parse(od);
                delete od["id"];
                delete od["menu_cycle_day_id"];
                delete od['menu_cycle_day_option_components'];
                if (od.recipes.length > 0) {
                    od.recipes.map((oc) => {
                        delete oc["option_component_id"];
                        return oc;
                    });
                }
                option_data = od;
                // console.log("option_data 1", JSON.stringify(od));
                this.day_number = day;
                this.option_number = parseInt(total) + 1;

                this.closeOptionsModal(option_data.recipes, option_data.photo, day, this.option_number, option_data.name);
            }
        },

        addOptionDeleteScript(click_index, day) {
            let mc_option_id = "";
            if (confirm("Are you sure you want to delete this option?")) {
                if (day == 1) {
                    mc_option_id = this.mc_final_options_mon[click_index].id;
                    this.mc_final_options_mon.splice(click_index, 1);

                    this.mc_daily_sum_prod_mon_all_data.splice(click_index, 1);
                    // this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

                    // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);

                    this.avg_products_weekly_all_data[0].splice(click_index, 1);
                    this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
                    this.totalPlannedNumber('mon');
                }
                if (day == 2) {
                    mc_option_id = this.mc_final_options_tue[click_index].id;
                    this.mc_final_options_tue.splice(click_index, 1);

                    this.mc_daily_sum_prod_tue_all_data.splice(click_index, 1);

                    // this.mc_daily_sum_prod_tue = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_tue_all_data);

                    // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);

                    this.avg_products_weekly_all_data[1].splice(click_index, 1);
                    this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
                    this.totalPlannedNumber('tue');
                }
                if (day == 3) {
                    mc_option_id = this.mc_final_options_wed[click_index].id;
                    this.mc_final_options_wed.splice(click_index, 1);

                    this.mc_daily_sum_prod_wed_all_data.splice(click_index, 1);
                    // this.mc_daily_sum_prod_wed = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_wed_all_data);
                    // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);

                    this.avg_products_weekly_all_data[2].splice(click_index, 1);
                    this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
                    this.totalPlannedNumber('wed');
                }
                if (day == 4) {
                    mc_option_id = this.mc_final_options_thu[click_index].id;
                    this.mc_final_options_thu.splice(click_index, 1);

                    this.mc_daily_sum_prod_thu_all_data.splice(click_index, 1);
                    // this.mc_daily_sum_prod_thu = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_thu_all_data);

                    // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);

                    this.avg_products_weekly_all_data[3].splice(click_index, 1);
                    this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
                    this.totalPlannedNumber('thu');
                }
                if (day == 5) {
                    mc_option_id = this.mc_final_options_fri[click_index].id;
                    this.mc_final_options_fri.splice(click_index, 1);

                    this.mc_daily_sum_prod_fri_all_data.splice(click_index, 1);
                    // this.mc_daily_sum_prod_fri = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_fri_all_data);

                    // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);

                    this.avg_products_weekly_all_data[4].splice(click_index, 1);
                    this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
                    this.totalPlannedNumber('fri');

                }
                if (day == 6) {
                    mc_option_id = this.mc_final_options_sat[click_index].id;
                    this.mc_final_options_sat.splice(click_index, 1);

                    this.mc_daily_sum_prod_sat_all_data.splice(click_index, 1);
                    // this.mc_daily_sum_prod_sat = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sat_all_data);

                    // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);

                    this.avg_products_weekly_all_data[5].splice(click_index, 1);
                    this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
                    this.totalPlannedNumber('sat');

                }
                if (day == 7) {
                    mc_option_id = this.mc_final_options_sun[click_index].id;
                    this.mc_final_options_sun.splice(click_index, 1);

                    this.mc_daily_sum_prod_sun_all_data.splice(click_index, 1);
                    // this.mc_daily_sum_prod_sun = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sun_all_data);

                    // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);

                    this.avg_products_weekly_all_data[6].splice(click_index, 1);
                    this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
                    this.totalPlannedNumber('sun');

                }

                if (mc_option_id != "") {
                    this.deleted_mc_option_ids.push(mc_option_id);
                    console.log('deleted_mc_option_ids', this.deleted_mc_option_ids);
                    this.form.post(this.route('menu-cycle-option-delete', mc_option_id), {
                        onSuccess: () => {
                            this.$toast.success('MenuCycle option deleted successfully!');
                        }
                    });
                }
            }

        },
    }
}
</script>
